import React from 'react';
import { Box, Typography } from '@mui/material';
import StyledButton from '../UI/StyledButton';

const QuickCheckInActionFooter = ({
  helperText = 'Take your time.',
  primaryActionLabel,
  primaryActionIcon = null,
  onPrimaryAction,
  disabled = false,
}) => (
  <Box
    sx={{
      position: 'sticky',
      bottom: 0,
      zIndex: 2,
      mt: 2,
      pt: 1.5,
      pb: { xs: 0.5, sm: 0.75 },
      background: 'linear-gradient(180deg, rgba(255,255,255,0), rgba(255,255,255,0.92) 24%, rgba(255,255,255,1) 100%)',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'stretch', sm: 'center' },
        justifyContent: 'space-between',
        gap: 1.25,
      }}
    >
      <Typography sx={{ fontSize: '0.88rem', color: '#5B6A63', lineHeight: 1.45 }}>
        {helperText}
      </Typography>

      <StyledButton
        variant="contained"
        onClick={onPrimaryAction}
        disabled={disabled}
        startIcon={primaryActionIcon}
        sx={{
          minWidth: { xs: '100%', sm: 180 },
          height: 54,
          borderRadius: '18px',
          bgcolor: '#2e7d32',
          color: '#ffffff',
          fontWeight: 800,
          fontSize: '0.95rem',
          textTransform: 'none',
          width: { xs: '100%', sm: 'auto' },
          borderColor: '#2e7d32',
          '&:hover': {
            bgcolor: '#256628',
            borderColor: '#256628',
          },
          '&.Mui-disabled': {
            bgcolor: '#e3e3e5',
            color: '#b0b1b5',
          },
        }}
      >
        {primaryActionLabel}
      </StyledButton>
    </Box>
  </Box>
);

export default QuickCheckInActionFooter;
